import * as React from "react";
import { Path, Rect, G, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const AOIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="AO" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#1D1D1D"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F50100"
          fillRule="evenodd"
          d="M0 0v6h16V0H0Z"
          clipRule="evenodd"
        />
        <G filter="url(#c)">
          <Path
            fill="#FCFF01"
            d="M5.715 2.013c1.766 0 3.734 1.433 3.734 3.199 0 .746-.259 1.438-.688 1.989.788.393 1.454.703 1.454.703.247.162.316.594.154.84a.535.535 0 0 1-.74.155c-.001 0-.633-.373-1.018-.626-.177-.116-.383-.24-.6-.369-.506.34-1.11.54-1.76.54-.002-.001-2.349-.29-2.282-1.493.01.008.585.435 2.241.435.265 0 .497-.037.702-.102a68.135 68.135 0 0 0-1.335-.709c-.248-.162-.89-.984-.729-1.231.162-.248 1.143.032 1.39.194 0 .001.344.472.829.76.214.128.456.26.707.395.387-.479.51-1.095.51-1.481 0-2.047-2.539-3.185-2.569-3.199Zm1.087 2.26h.501l-.369.389.185.542L6.59 4.9l-.505.337.162-.576-.372-.368.502-.02.213-.57.212.57Z"
          />
          <Path
            fill="#FFEA42"
            d="M5.715 2.013c1.766 0 3.734 1.433 3.734 3.199 0 .746-.259 1.438-.688 1.989.788.393 1.454.703 1.454.703.247.162.316.594.154.84a.535.535 0 0 1-.74.155c-.001 0-.633-.373-1.018-.626-.177-.116-.383-.24-.6-.369-.506.34-1.11.54-1.76.54-.002-.001-2.349-.29-2.282-1.493.01.008.585.435 2.241.435.265 0 .497-.037.702-.102a68.135 68.135 0 0 0-1.335-.709c-.248-.162-.89-.984-.729-1.231.162-.248 1.143.032 1.39.194 0 .001.344.472.829.76.214.128.456.26.707.395.387-.479.51-1.095.51-1.481 0-2.047-2.539-3.185-2.569-3.199Zm1.087 2.26h.501l-.369.389.185.542L6.59 4.9l-.505.337.162-.576-.372-.368.502-.02.213-.57.212.57Z"
          />
        </G>
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
